import * as Permission from '../common/util/Permission';
import { StorageAdapter } from './utils/StorageAdapter.ts';

export const VIEW_MODE_PARTNER1 = 'partner1';
export const VIEW_MODE_PARTNER2 = 'partner2';
export const VIEW_MODE_DEVELOPER = 'developer';

/* this object can be used only in browser - in server we need multiple users */
let globalPermissionObject;

export function hasPermission(perm) {
    let permissionObject = globalPermissionObject;

    return Permission.hasPermissionInternal(perm, permissionObject);
}

export function hasOrganisationPermission(perm, organisationId) {
    let permissionObject = globalPermissionObject;

    return Permission.hasOrganisationPermissionInternal(perm, organisationId, permissionObject);
}


/**
 *
 * @param permissionObject
 */
export function setPermissionObject(permissionObject) {
    globalPermissionObject = permissionObject;
}

/**
 *
 * @returns permissionObject
 */
export function getPermissionObject() {
    return globalPermissionObject;
}

let developerMode = true;

/* read developer mode from local storage */
if (typeof window === 'object' && 'localStorage' in window) {
    const storedValue = StorageAdapter.getSync('developerMode');
    if (storedValue !== undefined && storedValue !== null) {
        developerMode = storedValue === "true" ? true : false;
    }
}



export function toggleDeveloperMode() {
    developerMode = !developerMode;

    if (typeof window === 'object' && 'localStorage' in window) {
        StorageAdapter.setSync('developerMode', String(developerMode));
    }

    return developerMode;
}

export function toggleViewMode(type) {
    if (typeof window === 'object' && 'localStorage' in window) {
        if (type === VIEW_MODE_PARTNER1 || type === VIEW_MODE_PARTNER2 || type === VIEW_MODE_DEVELOPER) {
            StorageAdapter.setSync('viewMode', type);
            console.log('viewMode', type);
        } else {
            StorageAdapter.removeSync('viewMode');
        }

        // Keep developer mode in sync with view mode selection so switching to "regular user"
        // actually reduces the UI (otherwise developerMode stays true in memory for the whole session).
        developerMode = type === VIEW_MODE_DEVELOPER;
        StorageAdapter.setSync('developerMode', String(developerMode));
    }
}

export function getViewMode() {
    if (typeof window === 'object' && 'localStorage' in window) {
        return StorageAdapter.getSync('viewMode');
    }
    return null;
}

export function getDeveloperMode() {
    return developerMode || getViewMode() === VIEW_MODE_DEVELOPER;
}

export function canHaveDeveloperMode() {
    return hasPermission(Permission.PERM_DEVELOPER) || hasPermission(Permission.PERM_INSTANCE_SUPPORT) || hasPermission(Permission.PERM_INSTANCE_ADMIN);
}

export function developerModeEnabled(organisationId) {
    if (getDeveloperMode() || getViewMode() === VIEW_MODE_DEVELOPER) {
        if (organisationId && hasOrganisationPermission(Permission.PERM_DEVELOPER, organisationId)) {
            return true;
        } else if (canHaveDeveloperMode()) {
            return true;
        }
    }
    return false;
}


export function isDeveloper(orgId) {
    return (canHaveDeveloperMode()) && (developerModeEnabled(orgId));
}
export function isPartner2(orgId) {
    return hasPermission(Permission.PERM_PARTNER2) || isDeveloper(orgId) || getViewMode() === VIEW_MODE_PARTNER2;
}
export function isPartner1(orgId) {
    return hasPermission(Permission.PERM_PARTNER1) || isDeveloper(orgId) || isPartner2(orgId) || getViewMode() === VIEW_MODE_PARTNER1;
}
